import androidx.compose.runtime.Composable
import net.sergeych.ugdx.shared.Currency
import frontend.pages.TradeOrderType
import frontend.pages.TransferType
import org.jetbrains.compose.web.attributes.name
import org.jetbrains.compose.web.attributes.selected
import org.jetbrains.compose.web.dom.*

class TradeOrderSelectAttrsBuilder {
    var isCondensed = false
    var onChange: (value: TradeOrderType?) -> Unit = {}
    var label: @Composable() () -> Unit = {}
    var options: List<TradeOrderType> = TradeOrderType.values().toList()

    fun onChange(handler: (value: TradeOrderType?) -> Unit) { onChange = handler }
    fun label(l: @Composable() () -> Unit) { label = l }
    fun condensed() { isCondensed = true }
}

@Composable
fun TradeOrderTypeSelect(
    id: String,
    selected: TradeOrderType?,
    attrs: TradeOrderSelectAttrsBuilder.() -> Unit = {}
) {
    val builder = TradeOrderSelectAttrsBuilder()
    attrs.invoke(builder)

    Div() {
        if (!builder.isCondensed) Label(forId = id, attrs = {
            classes("block", "text-sm", "font-medium", "text-gray-700")
        }) { builder.label() }

        Select(attrs = {
            id(id)
            name("select")
            classes("mt-1", "block", "w-full", "pl-3", "pr-10",
                if (builder.isCondensed) "py-1" else "py-2",
                "text-base", "border-gray-300", "focus:outline-none", "focus:ring-indigo-500", "focus:border-indigo-500", "sm:text-sm", "rounded-md")
            onChange {
                val id = it.value
                val type = builder.options.find { it.toString() == id }
                builder.onChange(type)
            }
        }) {
            builder.options.forEach {
                val option = it

                Option(option.toString(), attrs = {
                    if (selected?.toString() == option.toString()) selected()
                }) { Text(option.title) }
            }
        }
    }
}